import React from "react";
import { BookOpen, ArrowRight } from "lucide-react";
import LocalDateTime from "services/date-converter";
import { useAccentColor } from "utils/accent-color";

// Related articles can span several chapters, so this is the one list where
// the chapter colour_code does real work — the left spine and the chapter
// label make the grouping readable without adding another line of text.
const RelatedArticleRow = ({ article, onOpen }) => {
  const accent = useAccentColor(article.knowledge_base?.color_code);

  return (
    <button
      type="button"
      onClick={() => onOpen(article.id)}
      className="relative flex items-start gap-3 p-3.5 pl-4 rounded-xl border border-border bg-surface text-left overflow-hidden"
    >
      <span className="absolute left-0 inset-y-0 w-1" style={{ backgroundColor: accent.base }} />

      {article.banner_image ? (
        <img
          src={article.banner_image}
          alt={article.title}
          className="flex-shrink-0 w-14 h-14 rounded-lg object-cover border border-border"
        />
      ) : (
        <div
          className="flex-shrink-0 w-14 h-14 rounded-lg flex items-center justify-center"
          style={{ backgroundColor: accent.softFill }}
        >
          <BookOpen size={18} style={{ color: accent.text }} />
        </div>
      )}
      <div className="min-w-0 flex-1">
        {article.knowledge_base?.title && (
          <p
            className="text-[10.5px] font-semibold uppercase tracking-wide mb-0.5 truncate"
            style={{ color: accent.text }}
          >
            {article.knowledge_base.title}
          </p>
        )}
        <p className="flex items-center gap-1.5 text-[13px] font-semibold text-text_primary leading-snug">
          <span className="line-clamp-2">{article.title}</span>
          {article.is_new && (
            <span className="flex-shrink-0 px-1.5 py-0.5 rounded text-[9px] font-bold uppercase tracking-wide bg-danger text-white">
              New
            </span>
          )}
        </p>
        <p className="text-[10.5px] text-text_muted mt-1">
          <LocalDateTime utcTime={article.published_at} type="date" />
        </p>
      </div>
      <ArrowRight size={14} className="flex-shrink-0 text-text_muted mt-1" />
    </button>
  );
};

const RelatedArticles = ({ articles = [], onOpen }) => {
  if (!articles.length) return null;

  return (
    <div className="mt-10 pt-8 border-t border-border">
      <p className="text-[13px] font-semibold uppercase tracking-wide text-text_muted mb-4">Related Articles</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {articles.map((article) => (
          <RelatedArticleRow key={article.id} article={article} onOpen={onOpen} />
        ))}
      </div>
    </div>
  );
};

export default RelatedArticles;
